// @react/hooks/useTeam.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { teamStore } from '@core/stores';

/**
 * React hook for Team operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useTeam } from '@react/hooks';
 *
 * const TeamList = observer(() => {
 *   const store = useTeam();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useTeam() {
  return teamStore;
}
